<template>
  <div id="app" :style="colors">
<!--    <Header v-if="$route.meta.hideHeader"/>-->
    <router-view/>
<!--    <Footer/>-->
  </div>
</template>

<script>
// import Header from './components/Header';
// import Footer from './components/Footer';
import config from './scanner.config';

export default {
  // components: {Footer, Header}
  computed: {
    colors() {
      return {
        '--bg': config.colors.idle.background,
        '--text': config.colors.idle.text,
        '--bg-success': config.colors.scanSuccess.background,
        '--text-success': config.colors.scanSuccess.text,
        '--bg-fail': config.colors.scanFail.background,
        '--text-fail': config.colors.scanFail.text,
        '--accent': config.colors.accent
      }
    }
  }
}
</script>


<style lang="less">
@import (css) url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;600;700&family=Source+Code+Pro:wght@400;600&display=swap');

html, body {
  padding: 0;
  margin: 0;
  height: 100%;
}

* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  box-sizing: border-box;
}

a {
  text-decoration: none;
  color: currentColor;
}

#app {
  font-family: Manrope, -apple-system, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  display: flex;
  flex-direction: column;
  background-color: var(--bg);
  color: var(--text);
  width: 100%;
  min-height: 100%;
}
</style>
